import { Card } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CommitChart from "./CommitChart";
import LinesAddedChart from "./LinesAddedChart";

function GitDashboardChart() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [projects, setProjects] = useState([]);
    const [users, setUsers] = useState([]);

    const [formDataFordropDowns, setFormDataForDropDowns] = useState({
        staff_id,
    });

    const {
        status: gitUserStatus,
        data: gitUserRes,
        refetch: getGitUsers,
    } = useQuery(
        "gitUsers",
        async () => {
            return await HTTP("/analytics/getGitUsers", {
                ...formDataFordropDowns,
            });
        },
        { enabled: false },
    );

    const {
        status: gitProjectStatus,
        data: gitProjectRes,
        refetch: getGitProjects,
    } = useQuery(
        "gitProjects",
        async () => {
            return await HTTP("/analytics/getGitProjects", {
                ...formDataFordropDowns,
            });
        },
        { enabled: false },
    );
    useEffect(() => {
        getGitUsers();
        getGitProjects();
    }, []);

    useEffect(() => {
        if (gitProjectStatus === "success") {
            setProjects(gitProjectRes.data);
        }
    }, [gitProjectStatus, gitProjectRes]);

    useEffect(() => {
        if (gitUserStatus === "success") {
            setUsers(gitUserRes.data);
        }
    }, [gitUserStatus, gitUserRes]);

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <LinesAddedChart projects={projects} users={users} />
            <CommitChart projects={projects} users={users} />
        </Card>
    );
}

export { GitDashboardChart };
